import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=be511518&scoped=true"
import script from "./Note.vue?vue&type=script&lang=js"
export * from "./Note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be511518",
  null
  
)

export default component.exports